module.exports = __webpack_public_path__ + "img/09_manual_(white).72787de0.svg";